/** SQ-60: Feature toggle for Rearchive navigation link in provider sidebar */
export const SQ_60_REARCHIVE_NAVIGATION = 'SQ-60-rearchive-navigation';
